import React from 'react';
import '../style/BusStopBackground.css';


function BusStopBackground() {
    return (
        <>
        </>
    );
}

export default BusStopBackground;